import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDoorbellCameraProps } from './IconDoorbellCamera.types'
import * as Styled from './styles/IconDoorbellCamera.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDoorbellCamera: FC<IconDoorbellCameraProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDoorbellCameraProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDoorbellCameraProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M7.063 2.555H19V19.18a2.32 2.32 0 0 1-.676 1.64 2.32 2.32 0 0 1-1.64.68H7.059a2.076 2.076 0 0 1-2.07-2.078V4.632c0-1.148.929-2.077 2.074-2.077Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M7 5.031h10v10H7Zm0 0' vectorEffect='non-scaling-stroke' />
          <path
            d='m8.191 14.926.48-.684c.79-1.18 2-1.937 3.356-1.937 1.356 0 2.567.75 3.356 1.937l.433.79M14.453 9.64a2.426 2.426 0 1 1-2.426-2.422h2.426ZM7 18.031h5.508m4.492.035a1.12 1.12 0 1 1-2.24.002 1.12 1.12 0 0 1 2.24-.002Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDoorbellCamera
